module.exports = __webpack_public_path__ + "img/0B.44c4d7db.png";